/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Patients from './Patients/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Check/Content"
  
}) {
  return (<React.Fragment
>
<Patients
  viewPath={`${viewPath}/Patients`}
/>
{children}
</React.Fragment>)
}